import "./Cart.css";
import Item from "../Item/Item";
import {
  FinancialData,
  ItemDetailsData,
} from "../../../../Utils/DefinitionsInterfaces";
import { NFOLogoNoText } from "../../../../Assets/svgs";
import Subtotal from "../Subtotal/Subtotal";
import MultipleItems from "../Item/MultipleItems";
import { motion } from "framer-motion";
import { formatExamDate } from "../../../../Utils/dateFormatter";

interface CartProps {
  stateDefaultItems: FinancialData[];
  stateCheckoutItems: ItemDetailsData[];
  cbRemoveProduct: (itemId: number) => void;
  cbHandlePaymentClick: () => void;
}

const Cart = (props: CartProps) => {
  return (
    <div className="cart-parent-wrapper">
      <div className="cart">
        <div className="cart-child">
          <div className="cart-title">
            <div>
              <div className="text-wrapper-2">Purchase Details</div>
            </div>
            <img
              src={NFOLogoNoText}
              alt="NFO Logo"
              className="nfo-logo-details-section"
            />
          </div>

          {props.stateCheckoutItems.length > 1 ? (
            <MultipleItems
              stateCheckoutItems={props.stateCheckoutItems}
              cbRemoveProduct={props.cbRemoveProduct}
              key={`multiple-items-${props.stateCheckoutItems.length}`}
              isDefaultItem={true}
            />
          ) : (
            props.stateCheckoutItems.map((e, i) => (
              <Item
                stateCheckoutItem={e}
                cbRemoveProduct={props.cbRemoveProduct}
                key={`item-${i}`}
                isDefaultItem={true}
              />
            ))
          )}
        </div>
        <div className="button-container">
          <Subtotal
            stateCheckoutItems={props.stateCheckoutItems}
            cbHandlePaymentClick={props.cbHandlePaymentClick}
          />
        </div>
      </div>
    </div>
  );
};

export default Cart;
